export default function AddUsersIco({ color }) {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.1598 17.5V12.5M13.6598 15H18.6598M10.3265 12.5H6.99316C5.44003 12.5 4.66346 12.5 4.05089 12.7537C3.23413 13.092 2.58521 13.741 2.2469 14.5577C1.99316 15.1703 1.99316 15.9469 1.99316 17.5M13.2432 2.7423C14.4648 3.23679 15.3265 4.43443 15.3265 5.83333C15.3265 7.23224 14.4648 8.42988 13.2432 8.92437M11.5765 5.83333C11.5765 7.67428 10.0841 9.16667 8.24316 9.16667C6.40222 9.16667 4.90983 7.67428 4.90983 5.83333C4.90983 3.99238 6.40222 2.5 8.24316 2.5C10.0841 2.5 11.5765 3.99238 11.5765 5.83333Z"
        stroke="#344054"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
